import React from 'react';

import './Styles.scss';
import './styles.css';

const Es = () => {
  return (
    <div className=" privacy-page ">
      <h2>Política de Privacidad de BASF</h2>
      <p>
        BASF se siente halagada por su visita a nuestro sitio web/aplicación.
        Gracias por su interés en nuestra empresa.
      </p>
      <br />
      <p>
        En BASF, la protección de datos es una prioridad. Esta página está
        diseñada para proporcionar información sobre cómo seguimos los
        estándares de protección de datos, qué información recopila mientras
        navega por nuestro sitio web/aplicación y cómo esa información es
        recopilada, tratada, utilizada y protegida por nosotros de acuerdo con
        la Ley N° 13.709/ 2018 (Ley General de Protección de Datos - “LGPD”), de
        modo que las disposiciones contenidas en esta política reflejen los
        aspectos abarcados por la legislación brasileña.
      </p>
      <br />
      <p>
        Primera y más importante disposición: los únicos datos personales
        tratados se encuentran en expresamente detallados y no se utilizarán
        para ningún otro fin sin su consentimiento expreso.
      </p>
      <p>
        La presente Política de Privacidad de Datos se aplica a la recopilación
        y procesamiento de datos únicamente para las siguientes
        plataformas/frentes de comunicación: marketing por correo electrónico,
        medios sociales (Facebook, LinkedIn y YouTube), aplicación para
        teléfonos móviles, sitio web corporativo y WhatsApp (recepción de
        contenidos e información de marca).
      </p>
      <br />

      <h2>Recolección de datos</h2>
      <p>
        Luego de la autenticación del usuario, la aplicación almacena la fecha y
        hora de acceso, información asociada al registro del usuario.
      </p>
      <br />
      <p>
        Para el uso de la aplicación es necesario recabar los siguientes datos
        personales: nombre, teléfono celular y correo electrónico de los
        usuarios. Se requiere móvil para el proceso de doble autenticación de la
        aplicación. Se requiere un correo electrónico para enviar una solicitud
        de cotización de producto y la aplicación almacena el historial de
        pedidos. También se almacenan los datos de conexión entre el usuario y
        el dispositivo multiscent, si el usuario dispone de uno. En el caso de
        posesión
      </p>
      <br />

      <h2>Recolección y tratamiento de datos personales</h2>
      <p>
        Los datos personales solo se recolectan cuando usted los proporciona en
        el curso, por ejemplo, al registrarse en nuestro sitio web/aplicación,
        al completar formularios o enviar correos electrónicos, o a través de
        pedidos de productos o servicios, consultas o solicitudes de material.
      </p>
      <br />
      <p>
        Sus datos personales permanecen en nuestra empresa, nuestras filiales y
        nuestro proveedor, y pueden ser compartidos por BASF sólo con sus
        proveedores/prestadores de servicios que necesiten acceder a dichos
        datos para cumplir sus obligaciones con BASF. En este caso, dichos
        proveedores/prestadores de servicios sólo podrán utilizar sus datos
        personales de acuerdo con nuestras instrucciones y con los fines
        establecidos a continuación en la presente Política y están obligados
        contractualmente a cumplir con los requisitos legales de protección de
        datos aplicables.
      </p>
      <br />
      <p>
        Los datos personales que recopilemos solo se utilizan para cumplir con
        nuestras obligaciones con usted y mantenerlo informado sobre eventos,
        contenidos/estudios técnicos, productos, servicios, encuestas de opinión
        sobre productos y servicios y/u otra información de BASF, según su
        perfil, a través de correos electrónicos de marketing. BASF también
        podrá utilizar los datos recopilados para el desarrollo de estudios,
        investigaciones y análisis de marketing interno, realizados para mejorar
        nuestras acciones. Además, para garantizar la calidad, así como por
        razones legales, de seguridad y de capacitación, podemos monitorear,
        grabar y archivar llamadas, conversaciones de chat y otras
        comunicaciones.
      </p>
      <br />
      <p>
        Importante: sus datos personales sólo serán utilizados para cualquier
        otro propósito cuando usted haya dado su consentimiento específico para
        hacerlo. Uno puede revocar su consentimiento para el uso de sus datos
        personales en cualquier momento, enviando un correo electrónico a
        <a href="mailto:data-protection.br@basf.com">
          data-protection.br@basf.com
        </a>{' '}
        con la solicitud de revocación de su consentimiento a la dirección de
        correo electrónico del Oficial de Datos, informado al final de esta
        Política. Tenga en cuenta que esta revocación del consentimiento puede
        afectar la disponibilidad de ciertos servicios y programas, así como su
        acceso a la información sobre BASF, que se comparte a través de canales
        digitales, como correos electrónicos de marketing enviados en función de
        sus intereses.
      </p>
      <br />
      <p>
        Incluso después de la terminación de la relación contractual, podemos
        tratar algunos de sus datos personales para ejercer nuestros derechos
        garantizados por la ley, incluso como prueba en procedimientos
        judiciales, administrativos o de arbitraje, especialmente los
        relacionados con la resolución de quejas que le impliquen a usted y/o a
        terceros.
      </p>
      <br />

      <h2>Almacenamiento de datos</h2>
      <p>
        Nosotros almacenamos datos personales durante el período necesario para
        realizar un servicio que ha solicitado o para cumplir con los fines para
        los que ha otorgado su permiso, siempre que no existan requisitos
        legales en contrario, por ejemplo, en el caso de los períodos de
        retención requeridos por el normas comerciales o fiscales.
      </p>

      <h2>Seguridad</h2>
      <p>
        BASF cuenta con medidas de seguridad técnicas y organizativas para
        evitar la manipulación, pérdida, destrucción o acceso por personas no
        autorizadas, de la información que usted pone a disposición. Cuando se
        reúnan y procesen datos personales, la información se transferirá en
        forma codificada para evitar el uso indebido de los datos por terceros.
        Nuestras medidas de seguridad son continuamente analizadas y revisadas
        de acuerdo con la tecnología apropiada.
      </p>
      <br />
      <p>
        Aunque BASF hace todo lo posible por preservar su privacidad y proteger
        sus datos personales, ninguna transmisión de información es
        completamente segura, por lo que BASF no puede garantizar plenamente que
        no se acceda a toda la información que usted reciba y/o envíe sin
        autorización, mediante métodos diseñados para obtener información de
        forma indebida, como fallos técnicos, virus o invasiones de la base de
        datos del sitio.
      </p>
      <br />
      <p>
        En cualquier situación, en el caso improbable de que se produzca tal
        acontecimiento, BASF garantiza sus mejores esfuerzos para remediar las
        consecuencias del suceso. BASF no es responsable de ningún otro sitio al
        que se pueda acceder desde el nuestro y no existe ningún vínculo entre
        dichas direcciones.
      </p>

      <h2>Derecho a obtener y rectificar información</h2>
      <p>
        Usted tiene derecho a obtener información sobre todos sus datos
        personales almacenados, a recibirla, a examinarla y, si es necesario, a
        modificarla o eliminarla. Para hacer esto, simplemente envíe un correo
        electrónico a la dirección de correo electrónico del Oficial, que se
        informa al final de esta Política. La eliminación de sus datos
        personales se llevará a cabo a menos que estemos obligados por ley a
        almacenar dicha información (según el ítem "Retención de datos"
        anterior).
      </p>
      <br />
      <p>
        BASF hará todo lo posible para cumplir con las solicitudes de los
        Usuarios en el menor tiempo posible. En caso de una solicitud de
        supresión, se respetará el período mínimo de almacenamiento de
        información de los usuarios de aplicaciones de Internet, determinado por
        la legislación brasileña, además de otras leyes aplicables, como la
        legislación laboral y fiscal.
      </p>

      <h2>Cookies</h2>
      <p>
        Cookies son pequeños archivos de texto compartidos entre su navegador
        web y nuestro sitio web, y que se almacenan en el navegador del
        dispositivo del espectador para un sitio web visitado (servidor web,
        servidor). Se envía un cookie desde el servidor web al navegador o se
        genera en el navegador mediante un script (JavaScript). El servidor web
        puede leer la información de cookies directamente desde el servidor
        cuando el usuario vuelve a visitar una página o transferir la
        información de cookies al servidor a través de un script del sitio web.
        Cookies no dañan su dispositivo, no contienen virus, troyanos u otro
        malware.
      </p>
      <p>
        La información se almacena en una cookie relacionado con el dispositivo
        específico utilizado. Sin embargo, esto no significa que obtenemos
        conocimiento directo de su identidad.
      </p>
      <br />
      <p>
        En general, utilizamos cookies para poder brindarle una mejor
        experiencia en todos los aspectos cuando navega por nuestra plataforma.
      </p>
      <p>Generalmente utilizamos las siguientes cookies:: </p>
      <ol>
        <li>
          <strong>Cookies estrictamente necesarias</strong>
        </li>
        <p>
          Estas cookies son necesarias para que el sitio web funcione. En
          general, sólo se establecen en respuesta a acciones que usted realiza
          y que equivalen a una solicitud de servicios, como la configuración de
          sus preferencias de privacidad, el inicio de sesión o el llenado de
          formularios. Se puede configurar su navegador para bloquear estas
          cookies o para que se le notifique sobre ellas. Sin embargo, es
          posible que algunas áreas del sitio no funcionen correctamente si se
          bloquea este tipo de cookies.
        </p>
        <p>
          Utilizamos estas cookies sobre la base legal de Interés Legítimo,
          previsto en el artículo 7, apartado IX, de la LGPD.
        </p>
        <li>
          <strong>Cookies de rendimiento</strong>
        </li>
        <p>
          Estas cookies nos permiten contar las visitas y analizar el tráfico
          para que podamos medir y mejorar el rendimiento de nuestro sitio web.
        </p>
        <p>
          Dichas cookies nos ayudan a responder preguntas sobre qué páginas son
          las más populares, cuáles son las menos utilizadas, así como las
          preferencias de acceso de los visitantes dentro del sitio. Toda la
          información recopilada por estas cookies es agregada y, por lo tanto,
          anónima. Si no se permite estas cookies, no podemos saber cuándo usted
          ha visitado nuestro sitio web.
        </p>
        <p>
          La base legal para el tratamiento de estas cookies es el
          consentimiento, previsto en el artículo 7, apartado I, de la LGPD.
        </p>
        <p>
          Es su derecho revocar su consentimiento en cualquier momento, sin que
          ello afecte a la licitud del tratamiento realizado sobre la base del
          consentimiento hasta su revocación. Para hacerlo, cambie la
          configuración en el Centro de Preferencias de Privacidad.
        </p>
        <li>
          <strong>Cookies funcionales</strong>
        </li>
        <p>
          Estas cookies permiten que el sitio web brinde una mejor funcionalidad
          y personalización. Pueden ser establecidos por nosotros o por terceros
          cuyos servicios utilizamos en nuestras páginas. Si usted no permite
          estas cookies, es posible que algunos o todos estos servicios no
          funcionen correctamente.
        </p>
        <p>
          La base legal para el tratamiento de estas cookies es el
          consentimiento, previsto en el artículo 7, apartado I, de la LGPD.
        </p>
        <p>
          Es su derecho revocar su consentimiento en cualquier momento, sin que
          ello afecte a la licitud del tratamiento realizado sobre la base del
          consentimiento hasta su revocación. Para hacerlo, cambie la
          configuración en el Centro de Preferencias de Privacidad.
        </p>
        <li>
          <strong>Cookies con fines de marketing</strong>
        </li>
        <p>
          Estas cookies se pueden configurar a través de nuestro sitio web.
          Nuestros socios de marketing pueden utilizarlos para perfilar sus
          intereses y mostrarle anuncios relevantes en otros sitios web. Si
          estas cookies no están permitidas, usted tendrá acceso a una
          publicidad menos dirigida.
        </p>
        <p>
          La base legal para el tratamiento de estas cookies es el
          consentimiento, previsto en el artículo 7, apartado I, de la LGPD.
        </p>
        <p>
          Es su derecho revocar su consentimiento en cualquier momento, sin que
          ello afecte a la licitud del tratamiento realizado sobre la base del
          consentimiento hasta su revocación. Para hacerlo, cambie la
          configuración en el Centro de Preferencias de Privacidad.
        </p>
        <li>
          <strong>Gestión de cookies, finalidades y plazo de almacenaje</strong>
        </li>
        <p>
          Recopilamos las siguientes cookies, según su configuración en el
          Centro de Preferencias de Privacidad.
        </p>
        <table>
          <tr>
            <th>Nombre de la Cookie</th>
            <th>Objetivo</th>
            <th>Duración</th>
          </tr>
          <tr>
            <td>Capa de Cookie</td>
            <td>
              Esta cookie almacena el acuerdo del usuario con respecto a la
              aceptación de los usos de cookies.
            </td>
            <td>
              Borrado tan pronto como borre la memoria caché de su navegador.
            </td>
          </tr>
          <tr>
            <td>Cookie de Exención de Responsabilidad</td>
            <td>
              Esta cookie almacena el acuerdo de exención de responsabilidad del
              usuario en páginas protegidas por exención de responsabilidad.
            </td>
            <td>
              Borrado tan pronto como borre la memoria caché de su navegador.
            </td>
          </tr>
          <tr>
            <td>Cookie do Google Analytics</td>
            <td>
              Con esta cookie, la herramienta de análisis web llamada Google
              Analytics recopila información anónima sobre cómo se utiliza
              nuestro sitio web/aplicación. La información recopilada nos ayuda
              a hacer un continuo seguimiento de las necesidades de nuestros
              visitantes. La información que se almacena es, por ejemplo,
              cuántas personas visitan nuestro sitio web/aplicación, de qué
              sitios web provienen y qué páginas ven.
            </td>
            <td>Expira automáticamente a los 50 meses.</td>
          </tr>
          <tr>
            <td>Cookie de Google Ads</td>
            <td>
              Esta cookie conserva información sobre la navegabilidad, como las
              páginas visitadas en el sitio web/aplicación, procedente del motor
              de búsqueda de Google.
            </td>
            <td>
              Política aplicable a Google Analytics (Expira automáticamente a
              los 50 meses).
            </td>
          </tr>
          <tr>
            <td>Marketing Cloud (Sales Force)</td>
            <td>
              Esta cookie almacena datos personales proporcionados por los
              usuarios, para ser utilizados por BASF de acuerdo con el ítem
              "Recolección y Procesamiento de Datos" de esta Política.
            </td>
            <td>
              Los datos se pueden eliminar en cualquier tiempo, a petición del
              usuario.
            </td>
          </tr>
          <tr>
            <td>Cookie de LinkedIn</td>
            <td>
              Esta cookie almacena información sobre la política de privacidad y
              cookies de LinkedIn, navegabilidad, con fines publicitarios en el
              entorno digital.
            </td>
            <td>
              Según las políticas de privacidad y cookies de LinkedIn,
              navegabilidad, con fines publicitarios en el entorno digital, el
              usuario puede desactivar la función de almacenamiento de datos en
              cualquier momento.
            </td>
          </tr>
        </table>
        <p>
          La activación o desactivación de la recolección de las cookies
          descritas está en su potestad, según la categoría, a través de las
          preferencias de cookies configuradas en el Centro de Preferencias de
          Privacidad. Solo las cookies estrictamente necesarias están activadas
          por defecto.
        </p>
        <p>
          Si tampoco desea el uso de cookies de esa naturaleza, usted tiene la
          opción de rechazar las cookies en su navegador. Para ello, facilitamos
          el acceso a esta función para los principales navegadores en los
          siguientes enlaces:
        </p>
        <ul>
          <li>
            <a href="https://support.google.com/chrome/answer/95647?hl=pt-BR">
              Google Chrome:
              https://support.google.com/chrome/answer/95647?hl=pt-BR
            </a>
            ;
          </li>
          <li>
            <a href="https://support.microsoft.com/pt-br/topic/excluir-e-gerenciar-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-11">
              Internet Explorer:
              https://support.microsoft.com/pt-br/topic/excluir-e-gerenciar-cookies-168dab11-0753-043d-7c16-ede5947fc64d#ie=ie-11
            </a>
            ;
          </li>
          <li>
            <a href="https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento">
              Firefox:
              https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento
            </a>
            ;
          </li>
          <li>
            <a href="http://safari.helpmax.net/ps/privacidade-e-seguranca/como-remover-cookies/">
              Safari:
              http://safari.helpmax.net/ps/privacidade-e-seguranca/como-remover-cookies/
            </a>
            .
          </li>
        </ul>
        <p>
          Es importante recordar que algunas de estas cookies son esenciales
          para la navegación, por lo que la funcionalidad del sitio web visitado
          puede verse afectada en caso de desactivación o no aceptación de las
          mismas.
        </p>
        <p>
          Si desea obtener más información o resolver cualquier duda sobre cómo
          recopilamos y procesamos su información a través de las cookies,
          contáctenos a través del correo electrónico/enlace
          <a href="mailto:data-protection.br@basf.com">
            data-protection.br@basf.com
          </a>
        </p>
      </ol>

      <h2>Legislación Aplicable y Jurisdicción</h2>
      <p>
        Esta Política será interpretada de conformidad con las leyes, normas y
        reglamentos de Brasil, en idioma portugués, especialmente de conformidad
        con la Ley N° 13.709/2018 (Ley General de Protección de Datos).
        Cualquier conflicto será resuelto en territorio nacional y de
        conformidad con la legislación brasileña aplicable y vigente en ese
        momento.
      </p>

      <h2>Contacto - Oficial de datos</h2>
      <p>
        El constante desarrollo de Internet hace que necesitemos ajustar
        periódicamente nuestras normas de protección de datos. Nos reservamos el
        derecho de implementar cambios apropiados en cualquier momento. Si tiene
        alguna pregunta o sugerencia, comuníquese con el representante de
        protección de datos de BASF, quien estará encantado de atenderle a
        usted. Nuestro Oficial de Datos es:
      </p>
      <br />
      <h6>
        Andre de Oliveira
        <br />
        Data Protection Officer - Brasil
        <br />
        correo electrónico:{' '}
        <a href="mailto:data-protection.br@basf.com">
          data-protection.br@basf.com
        </a>
      </h6>
    </div>
  );
};

export default Es;
